/**
 * 橙色业务处理 域名规则不会携带zy
 * ui修改，logo修改，字段修改，知识点去掉
 */
import orangeModeSetting from './orangeSetting'
 var env = process.env.NODE_ENV
const currentOrigin = location.origin

const urlReg = /(pm|sc|jx|jz)(.zytest.net|.zy.com)/g
const iszy = urlReg.test(currentOrigin)

// 确认当前模式
const settings = orangeModeSetting

const getCurrentMode = (origin, type) => {
  const modeKey = Object.keys(settings).find(o => settings[o][type] == origin)
  return settings[modeKey]
}

// currentModeSetting 是指当前e教学项目域名
const currentModeSetting = getCurrentMode(currentOrigin, 'JX_URL')

const changeFieldname = (str) => {
  // 排除掉卓越域名ees
  if (iszy) return str
  const fieldMap = {
    '学科': '领域',
    '科目': '领域',
    '年级': '年龄',
    '层级': '代号',
  }
  const testfield = /学科|科目|年级|层级/g
  return str.replace(testfield, $0 => fieldMap[$0])
}
console.log('------>', currentModeSetting, currentOrigin, iszy)
export default {
  currentOrigin,
  iszy,
  changeFieldname,
  ...currentModeSetting
}
